import type { IProductParams, IProductFilter, IProductResponse } from '~/types/product-listing'
import type { ProductFilterInputType, MenuCategory } from '~/types/product-filter';
import {displaySgPrice} from "~/utils/displayPrice";
interface PropTerms {
  [key: string]: string[]
}

interface SelectedParams {
  [key: string]: string[];
}

interface Relevant {
  [key: string]: string[];
}

export function useProductFilter(propTerms: PropTerms = {}, propTax: string = '') {
  const userStore = useUserStore();
  const { productParams, resetParams } = useProductState()
  const dataFilters = ref([]);
  const dataShortFilters = ref<MenuCategory>();
  // const dataFilters = useState('dataFilters', () => null)
  const rawDataFilter = ref('');
  const currentOrderByParams = ref('latest');
  const currentParams = ref({});
  const queryFilter = ref({})
  const lockedFilter = ref([]);
  const clearFilter = ref(false);
  const currentPriceFilter = ref('');
  const dataFilter = ref<IProductFilter>({ category: [], material: [], collection: [], gemstone: [], metal_color: [], recipients: [], minPrice: 0, maxPrice: 0 })
  const { $file } = useNuxtApp();
  const sorts = ['latest', 'price-low-to-high', 'price-high-to-low', 'bestsellers'];

  const getMatchingValues = (currentParams, subMenu) => {
    if( Object.keys(currentParams).length === 0 ) {
      return;
    }

    return currentParams.reduce((acc: string[], key: string) => {
      if (Object.keys(subMenu).includes(key)) {
        acc.push(key);
      }

      return acc;
    }, []);
  };

  const isPricePattern = (value: string): boolean => {
    const pattern = /^price-\d+@\d+$/;
    return pattern.test(value);
  }

  const extractUrlParams = (relevant = {}) => {
    const selectedParams: SelectedParams = {};
    if (propTerms[propTax]) {
        if (Array.isArray(propTerms[propTax])) {
          const foundSorts = propTerms[propTax].filter(term => sorts.includes(term));
          if (typeof foundSorts[0] !== 'undefined' ) {
            currentOrderByParams.value = foundSorts[0];
          }



          currentParams.value = propTerms[propTax].filter(term => !sorts.includes(term));
        }
      const newLockedFilter = { ...lockedFilter.value };

      if( typeof lockedFilter.value[propTax] == 'undefined' ) {
        const defaultCurrentParams = Array.isArray(currentParams.value[0]) ? currentParams.value[0] : [currentParams.value[0]];
        newLockedFilter[propTax] = defaultCurrentParams;
        selectedParams[propTax] = JSON.stringify(defaultCurrentParams);
      }

      // console.log('relevant', relevant);
      Object.entries(relevant as Relevant).forEach(([tax, item]) => {
        if (item.subMenu !== undefined ) {
          const matchingTerms = getMatchingValues(currentParams.value, item.subMenu);
          if( matchingTerms.length > 0 ) {
            // console.log(`matchingTerms - ${tax}`, matchingTerms);
            selectedParams[tax] = JSON.stringify(matchingTerms);

            newLockedFilter[tax] = matchingTerms;
          }
        }
      });
      if( Object.keys(newLockedFilter).length === 0 ) {
        newLockedFilter[propTax] = Array.isArray(currentParams.value[0]) ? currentParams.value[0] : [currentParams.value[0]];
        selectedParams[propTax] = JSON.stringify(currentParams.value);
      }


      const found = currentParams.value.find(item => isPricePattern(item));
      // console.log('found', found);
      if(found) {
        delete currentParams.value.price;
        const priceParams = found.replace('price-', '');
        const priceRange = priceParams.split('@').map(Number);
        selectedParams.price = `${displaySgPrice(priceRange[0])}@${displaySgPrice(priceRange[1])}`;
      }

      lockedFilter.value = newLockedFilter;
      // console.log('newLockedFilter', newLockedFilter);
    }

    return selectedParams;
  }

  const clearQueryFilter = (newLockedFilter = [], isClearAll: boolean) => {
    queryFilter.value = {};
    lockedFilter.value = newLockedFilter;

    if( isClearAll ) {
      clearFilter.value = true;
      // lockedFilter.value = [];
      // newLockedFilter = [];
      productParams.value.price = '';
      // productParams.value = {};
    }
    if( typeof newLockedFilter[propTax] !== 'undefined') {

      const processedDefaults = Object.entries(newLockedFilter).reduce((acc, [key, value]) => {
        acc[key] = Array.isArray(value) ? JSON.stringify(value) : value
        return acc
      }, {
        default: ''
      })

      if( productParams.value?.default ) {
        processedDefaults.default = productParams.value?.default;
      }
// console.log('newUrl111');
      resetParams(processedDefaults);
      return
    }
    // resetParams(processedDefaults);
    // productParams.value.price = '';
    // console.log('productParams.value', productParams.value);
  }

  const updatePriceInUrl = (url: string, newPriceValue: string) => {
    const cleanedUrl = url.replace(/\/price-\d+(@\d+)*\/?$/, '');
    return `${cleanedUrl.endsWith('/') ? cleanedUrl : `${cleanedUrl}/`}price-${newPriceValue.replace(/[^0-9@]/g, "")}/`;
  };

  const handleFilterPrice = (price: string) => {
    const currentPath = window.location.pathname;
    productParams.value.price = price;
    const url = `${currentPath}`;
    const updatedUrl = updatePriceInUrl(url, price);
    currentPriceFilter.value = price;
  }


  const getProductFilter = async() => {
    try {
      const { data, error } = await useAsyncData(
        'fetchFilterData',
        async () => {
          return $file.get('product-filters.json', {
            headers: {
              Authorization: `Bearer ${userStore.csrf}`,
              'X-API-Server': userStore.csrf_server
            },
          });
        }
      );

      const response = data.value as ProductFilterInputType;
      if( response ) {
        dataFilters.value = response;
      };

      const extractParms = extractUrlParams(response??{});
      currentParams.value = {
        ...extractParms,
        orderby: currentOrderByParams.value,
        default: propTax
      };
    } catch (err: any) {}
  }

  return {
    clearFilter,
    currentParams,
    lockedFilter,
    queryFilter,
    dataFilter,
    dataFilters,
    dataShortFilters,
    rawDataFilter,
    getProductFilter,
    clearQueryFilter,
    handleFilterPrice
  }
}